
// ignorePaths for singlepage persistence
var customIgnorePaths = {
    "krfc.fm": ["/shop/", "/cart/", "/checkout/"],
    "www.krfc.fm": ["/shop/", "/cart/", "/checkout/"],
    "dev-wkdu-wp.pantheonsite.io": ["/test/"],
    "kwmr.org": ["/archives/", "/"]
}

module.exports.addToIgnorePaths = function (existingIgnorePaths) {
    var hostname = location.hostname;
    return existingIgnorePaths.concat(customIgnorePaths[hostname]);
}


// WEBPACK FOOTER //
// ./util/custom/station-hacks.js